export default __webpack_public_path__ + "static/media/img--kitchen-1-light.8cc7f674.jpg";